export default __webpack_public_path__ + "static/media/zebra.26215613.png";